import { render, staticRenderFns } from "./VmsResponsiveList.vue?vue&type=template&id=37cd6b50"
import script from "./VmsResponsiveList.vue?vue&type=script&lang=js"
export * from "./VmsResponsiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports